import { SurveyComponent } from './pages/kios/survey/survey.component';
import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards';

export const routes: Routes = [
  // Auth routes (unauthorized)
  {
    path: 'login',
    loadChildren: () => import('./pages/auth').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'notfound',
    loadComponent: () =>
      import('./pages/not-found/notfound.component').then((m) => m.NotfoundComponent),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.component').then((m) => m.UnauthorizedComponent),
  },
  {
    path: 'kios',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/kios/main/main.component').then(
            (m) => m.MainComponent
          ),
      },
      {
        path: 'scan-information',
        loadComponent: () =>
          import('./pages/kios/scan-information/scan-information.component').then(
            (m) => m.ScanInformationComponent
          ),
      },
      {
        path: 'service-detail',
        loadComponent: () =>
          import('./pages/kios/service-detail/service-detail.component').then(
            (m) => m.ServiceDetailComponent
          ),
      },
      {
        path: 'survey',
        loadComponent: () =>
          import('./pages/kios/survey/survey.component').then(
            (m) => m.SurveyComponent
          ),
      },
      {
        path: 'search-result',
        loadComponent: () =>
          import('./pages/kios/search-result/search-result.component').then(
            (m) => m.SearchResultComponent
          ),
      },
      {
        path: 're-examination',
        loadComponent: () =>
          import('./pages/kios/re-examination/re-examination.component').then(
            (m) => m.ReExaminationComponent
          ),
      },
    ],
  },
  // Main application routes with ng-antd-admin layout
  {
    path: '',
    loadComponent: () =>
      import('./layout/default/default.component').then((m) => m.DefaultComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'clinic-dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        data: { key: 'dashboard' },
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('../app/pages/dashboard/components/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'clinic-dashboard',
        data: { key: 'clinic-dashboard' },
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('../app/pages/dashboard/components/clinic-dashboard/clinic-dashboard.component').then(
            (m) => m.ClinicDashboardComponent,
          ),
      },
      {
        path: 'settings/page-builder',
        loadChildren: () =>
          import('./pages/page-builder/page-builder.routes').then((m) => m.PAGE_BUILDER_ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'system/menu-management',
        data: { key: 'system-menu-management' },
        loadComponent: () =>
          import('./pages/menu-system/menu-management/menu-management.component').then(
            (m) => m.MenuManagementComponent,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'system/group-menu-management',
        loadChildren: () =>
          import('./pages/menu-system/menu-system.routes').then((m) => m.GROUP_MENU_SYSTEM_ROUTES),
        canActivate: [AuthGuard],
      },
      // Functions Management Routes
      {
        path: 'system/functions-management',
        loadChildren: () =>
          import('./pages/function-system/function-system.routes').then(
            (m) => m.FUNCTION_MANAGEMENT_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      // Group Functions Management Routes
      {
        path: 'system/group-functions-management',
        loadChildren: () =>
          import('./pages/function-system/function-system.routes').then(
            (m) => m.GROUP_FUNCTION_MANAGEMENT_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      // User Management Routes
      {
        path: 'auth/user-management',
        loadChildren: () =>
          import('./pages/auth/auth.routes').then((m) => m.USER_MANAGEMENT_ROUTES),
        canActivate: [AuthGuard],
      },
      // Synchronous Management Routes
      {
        path: 'system/config-system',
        loadChildren: () =>
          import('./pages/config-system/config-system.routes').then(
            (m) => m.CONFIG_SYSTEM_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      // Locations Management Route
      {
        path: 'system/locations',
        loadChildren: () =>
          import('./pages/locations/location.routes').then((m) => m.LOCATION_ROUTES),
        canActivate: [AuthGuard],
      },
      // Reception Management Route
      {
        path: 'system/reception',
        loadChildren: () =>
          import('./pages/reception/reception.routes').then((m) => m.RECEPTION_ROUTES),
        canActivate: [AuthGuard],
      },
      // System Management Route
      {
        path: 'system/sys-biz-type',
        data: { key: 'system-sys-biz-type' },
        loadComponent: () =>
          import('./pages/menu-system/sys-biz-type/sys-biz-type.component').then(
            (m) => m.SysBizTypeComponent,
          ),
        canActivate: [AuthGuard],
      },
      // Medical Examination Routes
      {
        path: 'examination',
        loadChildren: () =>
          import('./pages/examination/examination.routes').then((m) => m.EXAMINATION_ROUTES),
        canActivate: [AuthGuard],
      },
      // Thu tiền viện phí (Fee Collection) Routes
      {
        path: 'fee-collection',
        loadChildren: () =>
          import('./pages/fee-collection/fee-collection.routes').then((m) => m.FEE_COLLECTION_ROUTES),
        canActivate: [AuthGuard],
      },
      // Khám và điều trị (Examination and treatment) Routes
      {
        path: 'system/examination-treatment',
        loadChildren: () =>
          import('./pages/examination-treatment/examination-treatment.routes').then((m) => m.EXAMINATION_TREATMENT_ROUTES),
        canActivate: [AuthGuard],
      },
      // Phiếu nhập (Import Receipt) Routes
      {
        path: 'import-receipt',
        loadChildren: () =>
          import('./pages/import-receipt/import-receipt.routes').then((m) => m.IMPORT_RECEIPT_ROUTES),
        canActivate: [AuthGuard],
      },
      // Phiếu xuất (Export Receipt) Routes
      {
        path: 'export-receipt',
        loadChildren: () =>
          import('./pages/export-receipt/export-receipt.routes').then((m) => m.EXPORT_RECEIPT_ROUTES),
        canActivate: [AuthGuard],
      },
      // Khách hàng trả lại (Customer Return) Routes
      {
        path: 'customer-return',
        loadChildren: () =>
          import('./pages/customer-return/customer-return.routes').then((m) => m.CUSTOMER_RETURN_ROUTES),
        canActivate: [AuthGuard],
      },      
      {
        path: 'system/sys-logs',
        loadComponent: () =>
          import('./pages/logs/logs.component').then(
            (m) => m.LogsComponent,
          ),
        canActivate: [AuthGuard],
      },
    ],
  },
  // Fallback route
  {
    path: '**',
    redirectTo: '/notfound',
  },
];
